import { useRef, type TouchEvent } from "react";

const SWIPE_THRESHOLD = 50;

interface SwipeNavigationOptions {
  onNext: (() => void) | undefined;
  onPrev: (() => void) | undefined;
  enabled?: boolean;
}

export function useSwipeNavigation({ onNext, onPrev, enabled = true }: SwipeNavigationOptions) {
  const startRef = useRef<{ x: number; y: number } | null>(null);

  const onTouchStart = (e: TouchEvent) => {
    if (!enabled) return;
    const touch = e.touches[0];
    if (touch) {
      startRef.current = { x: touch.clientX, y: touch.clientY };
    }
  };

  const onTouchEnd = (e: TouchEvent) => {
    if (!enabled || !startRef.current) return;
    const touch = e.changedTouches[0];
    if (!touch) return;

    const deltaX = touch.clientX - startRef.current.x;
    const deltaY = touch.clientY - startRef.current.y;
    startRef.current = null;

    if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX < 0) {
        onNext?.();
      } else {
        onPrev?.();
      }
    }
  };

  return { onTouchStart, onTouchEnd };
}
